import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'iposcen-ipos-help-navigating-to-central',
  templateUrl: './ipos-help-navigating-to-central.component.html',
  styleUrls: ['./ipos-help-navigating-to-central.component.scss']
})
export class IposHelpNavigatingToCentralComponent implements OnInit {
  loginUserRole = sessionStorage.getItem('userRole');
  constructor() { }

  ngOnInit(): void {
  }

}
